export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}

export function formatCheckedAt(dateStr: string): string {
  try {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 1) return 'Vừa xong';
    if (diffMins < 60) return `${diffMins} phút trước`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours} giờ trước`;
    return dateStr.split(' ')[0];
  } catch {
    return dateStr;
  }
}

export function getStatusLabel(status: string): string {
  switch (status) {
    case 'normal': return 'Bình thường';
    case 'checking': return 'Đang kiểm tra';
    case 'warning': return 'Cảnh báo';
    case 'unavailable': return 'Không khả dụng';
    default: return status;
  }
}

export function getRegionFlag(code: string): string {
  const flags: Record<string, string> = {
    US: '🇺🇸', VN: '🇻🇳', HK: '🇭🇰', JP: '🇯🇵', KR: '🇰🇷',
    TW: '🇹🇼', SG: '🇸🇬', AU: '🇦🇺', UK: '🇬🇧', FR: '🇫🇷',
    TR: '🇹🇷', MY: '🇲🇾', TH: '🇹🇭', RU: '🇷🇺', CN: '🇨🇳',
  };
  return flags[code] || '🌐';
}